import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { debounceTime, skip } from 'rxjs';
import { FulfillService } from '../../fulfill.service';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'fulfill-header',
  templateUrl: './fulfill-header.component.html',
  styleUrls: ['./fulfill-header.component.scss'],
  standalone: false,
})
export class FulfillHeaderComponent implements OnInit {
  searchQuery = signal('');

  destroyRef = inject(DestroyRef);
  searchQueryDebounced = toObservable(this.searchQuery).pipe(
    skip(1),
    debounceTime(300),
    takeUntilDestroyed(this.destroyRef),
  );

  usePaginatedFulfillment = this.fulfillService.usePaginatedFulfillment;
  constructor(private fulfillService: FulfillService) {}

  ngOnInit(): void {
    if (this.usePaginatedFulfillment()) {
      this.listenToSearchQuery();
    }
  }

  listenToSearchQuery() {
    this.searchQueryDebounced.subscribe((text) => {
      this.filterTable(text);
    });
  }

  filterTable(text) {
    this.fulfillService.setFilter(text);
  }
}
